import { Injectable } from '@angular/core';
import { AppSettings } from 'app/app.settings';
import { BehaviorSubject } from 'rxjs';
import { CommonRequestService } from './common-request.service';
import { QaRuleCode, ResoCenterCol, ResolutionCenterService } from './resolution-center.service';

export interface ResoCenterCol_Domain extends ResoCenterCol {
	count: number;
	val?;
}
export interface QaResolverFeed_Domain {
	rule: QaRuleCode;
	count: number;
	cols: ResoCenterCol_Domain[];
}
export interface QaResolverFeed_DomainValue {
	value: any;
	count: number;
	newValue?;
	isValid?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ResolutionCenterDomainService {

	resoFeedDomainBS: BehaviorSubject<{
		feeds: QaResolverFeed_Domain[];
		layerId: number;
		selectedRule?: QaRuleCode;
		selectedColProp?: string;
	}> = new BehaviorSubject({
		layerId: null,
		feeds: null
	});

	domainValuesByRule: {
		[rule in QaRuleCode]?: {
			[colName: string]: QaResolverFeed_DomainValue[];
		}
	} = {};

	constructor(
		private requestService: CommonRequestService,
		private resoCenterService: ResolutionCenterService
	) { }

	getQaResolverFeedsDomain(layerId: number, layerCateCode: string) {
		return new Promise<QaResolverFeed_Domain[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/rcFeedDomain';
			const params: any = {
				layerId: layerId
			};
			this.requestService.requestGet(url, {
				params: params
			}, async (rsp) => {
				const feeds: QaResolverFeed_Domain[] = [];
				if (rsp.data) {
					const promises = [];
					rsp.data.forEach(i => {
						const promise = new Promise<void>(async (resolveP, rejectP) => {
							const colsByName = i.col_cnt;
							// .forEach(c => {
							// 	colsByName[Object.keys(c)[0]] = c[Object.keys(c)[0]];
							// });
							const cols = await this.resoCenterService.transformCols(Object.keys(colsByName), layerCateCode);
							const colsWithCount = cols.map(c => {
								return Object.assign({
									count: colsByName[c.standardName]
								}, c);
							});
							const feed: QaResolverFeed_Domain = {
								rule: i.gqr_cd,
								count: i.rul_cnt,
								cols: colsWithCount
							}
							feeds.push(feed);
							resolveP();
						});
						promises.push(promise);
					});
					await Promise.all(promises)
				}
				resolve(feeds);
			}, async err => reject(err));
		});
	}
	getQaResolverFeedsDomainValues(layerId: number, ruleCode: QaRuleCode, columnName: string, colProp: string) {
		// ruleCode = 'MSV';
		// columnName = 'IncMuni_L';
		return new Promise<QaResolverFeed_DomainValue[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/rcFeedDomain';
			const params: any = {
				layerId: layerId,
				ruleCode: ruleCode,
				columnName: columnName
			};
			this.requestService.requestGet(url, {
				params: params
			}, (rsp) => {
				const list: QaResolverFeed_DomainValue[] = [];
				if (rsp.data) {
					rsp.data.forEach(i => {
						list.push({
							value: i[colProp],
							count: i.cnt,
							isValid: true
						})
					});
				}
				this.domainValuesByRule[ruleCode][colProp] = list;
				resolve(list);
			}, async err => reject(err));
		});
	}
}
